import { Card, CardContent } from '@material-ui/core'
import { ArrowDropDown } from '@material-ui/icons'
import { Box, Typography } from '@mui/material'
import defaultPartThumb from '../../assets/img/default-part.png'
import { useDateFormatter } from '../../hooks/useDateFormatter'
import ActionsMenu from '../ActionsMenu/ActionsMenu'

interface Props {
  part: Part
  setPartToEdit: (part: Part) => void
  setShowAddEditPart: (show: boolean) => void
  setShowDeleteModal: (show: boolean) => void
  setPartToDelete: (part: Part) => void
}

const PartCard = ({
  part,
  setPartToEdit,
  setShowAddEditPart,
  setShowDeleteModal,
  setPartToDelete,
}: Props) => {
  const handleEditPart = () => {
    setPartToEdit(part)
    setShowAddEditPart(true)
  }

  const handleDeletePart = () => {
    setShowDeleteModal(true)
    setPartToDelete(part)
  }

  return (
    <div className={`card-wrapper part`}>
      <Card className={`white-card`}>
        <Box
          className={`thumbnail-container ${
            !part.thumbnail.id && 'no-thumbnail'
          }`}
          sx={{
            backgroundImage: part.thumbnail.id
              ? `url(${process.env.REACT_APP_API}/api/thumbnail/${part.thumbnail.id})`
              : `url(${defaultPartThumb})`,
          }}
        />
        <CardContent>
          <div className="content">
            <div className="flex align-center">
              <h4 className="m-b-0">{part.name}</h4>
              <ActionsMenu
                icon={<ArrowDropDown />}
                options={[
                  { onClick: handleEditPart, label: 'Edit' },
                  { onClick: handleDeletePart, label: 'Delete' },
                ]}
              ></ActionsMenu>
            </div>
            <Typography sx={{ minHeight: 20 }}>
              {part.size.x && (
                <>
                  {part.size.x}/{part.size.y}/{part.size.z} {part.size.units}
                </>
              )}
            </Typography>
            <p>{part.tolerance}</p>

            <div className="flex space-between last-updated">
              <p>
                <strong className="primary">Last updated:</strong>
              </p>
              <p>{useDateFormatter(part.updatedAt)}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default PartCard
